import { gql } from '@apollo/client';

export const AnalyzeSmartImportMutationName = 'AnalyzeSmartImport';

export const ANALYZE_SMART_IMPORT_MUTATION = gql`
  mutation ${AnalyzeSmartImportMutationName}($file: Upload!) {
    analyzeSmartImport(file: $file) {
      smartImport {
        id
        importMode
        status
      }
    }
  }
`;
